// Возврат с Яндекс ID или VK ID и кнопка «Войти на сайте» из чата с ботом Telegram: сервер открывает сайт
// с ?auth=<одноразовый код> или ?auth_error=<причина>. Код меняем на сессию до первой загрузки профиля и убираем метку
// из адреса. Аккаунт новый — предлагаем связать его с ботом Telegram или VK, чтобы баланс и ролики оттуда были видны на сайте.
import { ApiError, api, errorText } from './api';
import { getToken, setToken } from './platform';
import { navigate } from './router';
import { openSheet, toast } from './store';
import { S } from './strings';

const params = new URLSearchParams(window.location.search);
let code = params.get('auth');
let failure = params.get('auth_error');

function clearMark(): void {
  const q = new URLSearchParams(window.location.search);
  q.delete('auth');
  q.delete('auth_error');
  const search = q.toString();
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
}

/**
 * Вызвать при загрузке, до refreshMe. Срабатывает один раз. Возвращает текст ошибки, который показать, только если
 * после загрузки профиля человек так и не вошёл: кнопку «Войти на сайте» из чата часто нажимают, когда вкладка этого
 * браузера уже забрала вход сама, — код сгорел, но сессия уже есть, пугать «вход устарел» незачем.
 */
export async function redeemAuthReturn(): Promise<string | null> {
  const c = code;
  const f = failure;
  if (!c && !f) return null;
  code = null;
  failure = null;
  clearMark();
  if (f || !c) {
    toast(S.login.oauthError(f ?? ''), 'error', 6000);
    return null;
  }
  try {
    const r = await api.authRedeem(c);
    setToken(r.token);
    toast(S.login.success, 'success');
    if (r.next !== '/') navigate(r.next, { replace: true });
    if (r.created) openSheet({ kind: 'link', welcome: true });
  } catch (e) {
    const text = errorText(e) || S.login.authFailed;
    if (e instanceof ApiError && e.code === 'login_expired' && getToken()) return text;
    toast(text, 'error', 6000);
  }
  return null;
}
